<template>
  <div class="rmqclient-hint">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon :color="color" dark v-on="on">mdi-{{ icon }}</v-icon>
      </template>
      <span>{{ statusText }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'rmqclient-hint',
  computed: {
    ...mapGetters(['rmqhint']),
    color: function () {
      if (this.rmqhint === 0) {
        return 'red'
      } else if (this.rmqhint === 1) {
        return 'green darken-1'
      } else {
        return 'green darken-2'
      }
    },
    icon: function () {
      return this.rmqhint ? 'link' : 'link-off'
    },
    statusText: function () {
      return this.rmqhint
        ? this.$t('rmqc.online')
        : this.$t('rmqc.offline')
    }
  }
}
</script>

<style scoped>
.rmqclient-hint { cursor: default }
</style>
